import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import classes from './PopupAlert.module.scss';
import { ReactComponent as CloseSVG } from '../../assets/imgs/svg/close.svg';

class PopupAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: false,
    };
  }

  closeAlertWindow() {
    this.setState({
      hide: true,
    });
  }

  render() {
    const { t, theme } = this.props;
    const { hide } = this.state;

    if (hide) return null;

    return (
      <>
        <div className={`${classes.PopupAlert} ${theme ? classes[theme] : ''}`}>
          <div className={classes.Header}>
            <p>{t('popupAlert.noSpace')}</p>
            <button
              type="button"
              className={classes.CloseBtn}
              onClick={this.closeAlertWindow.bind(this)}
            >
              <CloseSVG />
            </button>
          </div>
          <div className={classes.Content}>
            <div className={classes.AlertStatic} />
            <div className={classes.ContentMessage}>
              <p className={classes.Header}>{t('popupAlert.smallDisplay')}</p>
              <p className={classes.Desc}>{t('popupAlert.desc_1')}</p>
              <p className={classes.Desc}>{t('popupAlert.desc_2')}</p>
              <p className={classes.Desc}>{t('popupAlert.desc_3')}</p>
              <button
                type="button"
                className={classes.AgreeBtn}
                onClick={this.closeAlertWindow.bind(this)}
              >
                {t('popupAlert.agree')}
              </button>
            </div>
          </div>
        </div>
        <div className={classes.Overlay} />
      </>
    );
  }
}

PopupAlert.propTypes = {
  t: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

PopupAlert.defaultProps = {
  theme: '',
};

export default withTranslation()(PopupAlert);
